import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const Dashboard = () => {
  const { t } = useTranslation("dashboard");

  return (
    <Box maxWidth="md" mx="auto">
      <Typography variant="h4" gutterBottom>{t("dashboard.dashboard")}</Typography>
      <Typography variant="h6" gutterBottom>{t("dashboard.dashboardText")}</Typography>
      <Box
        component="img"
        src="https://images.unsplash.com/photo-1555066931-4365d14bab8c"
        alt="Dashboard"
        sx={{ width: '100%', height: 256, objectFit: 'cover', borderRadius: 2, boxShadow: 2 }}
      />
    </Box>
  );
};